import React from 'react';
import { CHECKOUT_URL } from '../lib/constants';
import { trackInitiateCheckout } from '../lib/metaPixel';
type CTAButtonProps = {
  label?: string;
  subline?: string;
  variant?: 'primary' | 'gold';
  className?: string;
  pulse?: boolean;
};
export function CTAButton({
  label = '🦷 QUIERO EL SISTEMA OFM POR SOLO $12.99',
  subline,
  variant = 'primary',
  className = '',
  pulse = true
}: CTAButtonProps) {
  const base = variant === 'gold' ? 'bg-gold text-ofm-900 hover:bg-[#d9a94e]' : 'bg-ofm-600 text-white hover:bg-ofm-700';
  return <div className={`w-full ${className}`} data-id="element-76" data-mp="2oy6wxl204c3z">
      <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className={`${base} ${pulse ? 'cta-pulse' : ''} block w-full rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold leading-snug tracking-tight shadow-lg transition-colors duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-ofm-300 sm:px-8 sm:py-5 sm:text-lg`} data-id="element-77" data-mp="33pfm5t1zrvgl">
        {label}
      </a>
      {subline && <p className="mt-3 text-center text-[12px] font-medium leading-relaxed text-ofm-800/70 sm:text-sm" data-id="element-78" data-mp="19aheews6ex1e">
          {subline}
        </p>}
    </div>;
}